import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useLang } from "../i18n/LanguageContext";
import { CONTACT } from "../data/site";

const WhatsAppIcon = ({ className }) => (
  <svg viewBox="0 0 32 32" className={className} fill="currentColor" aria-hidden="true">
    <path d="M16.003 3C9.373 3 3.99 8.383 3.99 15.013c0 2.117.553 4.184 1.605 6.008L3.9 28.1l7.24-1.897a12.02 12.02 0 0 0 4.86 1.02h.004c6.63 0 12.013-5.383 12.013-12.013C28.017 8.383 22.633 3 16.003 3zm0 21.99h-.003a9.96 9.96 0 0 1-4.548-1.11l-.326-.194-4.297 1.127 1.147-4.19-.212-.335a9.93 9.93 0 0 1-1.523-5.27c0-5.514 4.487-10 10.006-10 5.517 0 10 4.486 10 10.001 0 5.514-4.483 9.97-10 9.97zm5.494-7.463c-.3-.15-1.78-.878-2.056-.978-.276-.1-.477-.15-.678.15-.2.3-.777.978-.953 1.178-.175.2-.35.226-.65.075-.3-.15-1.27-.468-2.42-1.492-.894-.797-1.498-1.782-1.673-2.082-.175-.3-.019-.462.132-.611.135-.135.3-.35.45-.526.15-.175.2-.3.3-.5.1-.2.05-.376-.025-.526-.075-.15-.677-1.632-.928-2.235-.244-.586-.492-.507-.677-.516l-.577-.01c-.2 0-.526.075-.802.376s-1.053 1.028-1.053 2.51 1.078 2.912 1.228 3.112c.15.2 2.122 3.24 5.14 4.544.718.31 1.278.494 1.715.632.72.229 1.376.196 1.894.119.578-.086 1.78-.727 2.03-1.43.25-.703.25-1.305.175-1.43-.075-.126-.276-.2-.576-.35z" />
  </svg>
);

export const FloatingWhatsApp = () => {
  const { t } = useLang();
  const [show, setShow] = useState(false);
  const [showLabel, setShowLabel] = useState(false);
  const waLink = `https://wa.me/${CONTACT.whatsapp}`;

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 300);
    onScroll();
    window.addEventListener("scroll", onScroll);
    const t1 = setTimeout(() => setShowLabel(true), 2200);
    const t2 = setTimeout(() => setShowLabel(false), 7000);
    return () => {
      window.removeEventListener("scroll", onScroll);
      clearTimeout(t1);
      clearTimeout(t2);
    };
  }, []);

  return (
    <AnimatePresence>
      {show && (
        <motion.a
          href={waLink}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="floating-whatsapp"
          initial={{ opacity: 0, scale: 0.5, y: 20 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0.5, y: 20 }}
          transition={{ type: "spring", stiffness: 260, damping: 20 }}
          onMouseEnter={() => setShowLabel(true)}
          onMouseLeave={() => setShowLabel(false)}
          className="fixed bottom-5 right-5 z-40 flex items-center gap-3 sm:bottom-7 sm:right-7"
          aria-label="WhatsApp"
        >
          <AnimatePresence>
            {showLabel && (
              <motion.span
                initial={{ opacity: 0, x: 10, width: 0 }}
                animate={{ opacity: 1, x: 0, width: "auto" }}
                exit={{ opacity: 0, x: 10, width: 0 }}
                className="hidden whitespace-nowrap rounded-full bg-white px-4 py-2 text-sm font-semibold text-purpleink-deep shadow-xl sm:block"
              >
                {t.wa_float}
              </motion.span>
            )}
          </AnimatePresence>
          <span className="relative flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-xl transition-transform duration-200 hover:scale-105 active:scale-95">
            <span className="absolute inset-0 animate-ping rounded-full bg-[#25D366] opacity-30" />
            <WhatsAppIcon className="relative h-8 w-8" />
          </span>
        </motion.a>
      )}
    </AnimatePresence>
  );
};
